var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.title !==undefined)?_c('h1',[_vm._v(_vm._s(_vm.title))]):_c('h1',[_vm._v(_vm._s(this.$root.get_translation('Route',this.$route.name,'label')))])
}
var staticRenderFns = []

export { render, staticRenderFns }